<template>
  <!-- Oct 2026 - the current user's open review tasks on ONE CompanySite (a new site added by a supplier, or a supplier's change
       request) -- each one is the standard task UI (SoloFlowNode: requested changes + Approve / Reject)
       used by CompanySiteDetail (vendor page Sites tab) and SharedCompanySitesManager -->
  <div
    v-if="tasks.length"
    class="company-site-review-tasks"
  >
    <div class="d-flex align-items-center mb-2 text-warning-darker font-weight-bold">
      <b-icon
        icon="exclamation-circle-fill"
        class="mr-2"
      ></b-icon>
      {{ $t('companySiteReviewTasks.waitingForYou') }}
    </div>
    <div
      v-for="task in tasks"
      :key="task.node_key"
      class="border rounded mb-2 overflow-hidden"
    >
      <SoloFlowNode
        flowObjectClass="CompanySite"
        :flowObjectId="siteId"
        :nodeKey="task.node_key"
        :hideHeader="true"
        class="p-3"
        @transition-completed="onTaskDone"
      ></SoloFlowNode> <!-- put all the content/titles/headers you need in the actual body for these -->
    </div>
  </div>
</template>

<script>
  import SoloFlowNode from '@/components/flows/components/SoloFlowNode.vue';

  export default {
    name: 'CompanySiteReviewTasks',
    components: {
      SoloFlowNode,
    },
    i18n: {
      // English only for now -- other languages fall back to English
      messages: {
        en: {
          companySiteReviewTasks: {
            waitingForYou: 'Waiting for your review',
          },
        },
      },
    },
    props: {
      siteId: {
        type: String,
        required: true,
      },
      tasks: {
        // [{ node_key, title }] -- CompanySiteReadSerializer.my_review_tasks
        type: Array,
        default: () => [],
      },
    },
    methods: {
      onTaskDone(payload) {
        // approved / rejected -- the parent reloads the site (its state / pending changes changed)
        this.$emit('review-done', payload);
      },
    },
  };
</script>
